/** @format */

import { ATCEventChildSku } from './atc-event-child-sku.interface';
import { HeaderStoreSelection } from './header-location.interface';
import { ATCEventSkuData } from './atc-event-sku-data.interface';

export interface ATCEvent {
  childSkuData?: ATCEventChildSku[];
  isBopis?: boolean;
  isClearance?: boolean;
  mainItem: boolean;
  message?: string;
  serviceStatus?: any;
  skuData?: ATCEventSkuData;
  storeDetails?: HeaderStoreSelection;
  success: boolean;
}
